import React, { useState, useContext, useEffect, useRef } from "react";
import { SketchPicker } from "react-color";
import { ClientContext } from "../../../contexts/ClientContext";
import { calcColorGradient } from "../../../helper/calcColorGradient";

const ColorSelector = ({ pickedColor, rowLabel, setDisplayColorSelector }) => {
  const [selectedColor, setSelectedColor] = useState(pickedColor.hex());
  const { updateCurrentSet } = useContext(ClientContext);
  const ref = useRef();

  useEffect(() => {
    const onBodyClick = (event) => {
      if (ref.current.contains(event.target)) {
        return;
      }
      setDisplayColorSelector(false);
    };
    document.body.addEventListener("click", onBodyClick, { capture: true });

    return () => {
      document.body.removeEventListener("click", onBodyClick, {
        capture: true,
      });
    };
  }, []);

  const onColorSelected = (hex) => {
    setSelectedColor(hex);
    updateCurrentSet(
      {
        color: rowLabel,
        pickedColor: hex,
        gradientOptions: calcColorGradient(hex),
      },
      false
    );
  };

  return (
    <div className="sketch-picker-container" ref={ref}>
      <SketchPicker color={selectedColor} onChange={(e) => onColorSelected(e.hex)} />
    </div>
  );
};

export default ColorSelector;
